interface TgWebApp {
  initData: string;
  ready: () => void;
  expand: () => void;
  close: () => void;
  MainButton: unknown;
  BackButton: unknown;
  HapticFeedback: {
    impactOccurred: (s: "light" | "medium" | "heavy" | "rigid" | "soft") => void;
    notificationOccurred: (s: "error" | "success" | "warning") => void;
    selectionChanged: () => void;
  };
  colorScheme: "light" | "dark";
  themeParams: Record<string, string>;
  viewportHeight: number;
  setHeaderColor: (c: string) => void;
  setBackgroundColor: (c: string) => void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

export function getTg(): TgWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function bootTelegram() {
  const tg = getTg();
  if (!tg) return;
  tg.ready();
  tg.expand();
  tg.setHeaderColor("#0b0d10");
  tg.setBackgroundColor("#0b0d10");
}

export const haptic = {
  tap: () => getTg()?.HapticFeedback.impactOccurred("light"),
  tick: () => getTg()?.HapticFeedback.selectionChanged(),
  win: () => getTg()?.HapticFeedback.notificationOccurred("success"),
  bust: () => getTg()?.HapticFeedback.notificationOccurred("error"),
};
